import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'do_these_policies_andor_procedures_have_a_reference_to_national'

export const dataPointDefinition = {
  retracedId: 'do_these_policies_andor_procedures_have_a_reference_to_national',
  name: 'Do these policies and/or procedures have a reference to national law and/or international requirements?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'REFERENCE_TO_NATIONAL_LAW',
      text: 'Reference to national law',
      externalIds: [
        {
          id: 'ms-1--1-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'REFERENCE_TO_INTERNATIONAL_LAW_ILO_CONVENTIONS',
      text: 'Reference to international law/ILO conventions',
      externalIds: [
        {
          id: 'ms-1--1-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe which international laws/ILO conventions are referenced:',
        externalIds: [
          {
            id: 'ms-1--1-2f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'REFERENCE_TO_OTHER_NATIONAL_OR_INTERNATIONAL_REQUIREMENTS_DECLA',
      text: 'Reference to other national or international requirements/declarations/goals/guiding principles etc.',
      externalIds: [
        {
          id: 'ms-1--1-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe which other national or international requirements / declarations / goals / guiding principles are referenced:',
        externalIds: [
          {
            id: 'ms-1--1-3f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'NO_REFERENCES_TO_ANY_OF_THE_ABOVE',
      text: 'No references to any of the above',
      externalIds: [
        {
          id: 'ms-1--1-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'REFERENCE_TO_NATIONAL_LAW',
                'REFERENCE_TO_INTERNATIONAL_LAW_ILO_CONVENTIONS',
                'REFERENCE_TO_OTHER_NATIONAL_OR_INTERNATIONAL_REQUIREMENTS_DECLA',
                'NO_REFERENCES_TO_ANY_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-pla-5',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 18260,
  sectionId: '2.2.6.10',
  impactArea: 'Policies and Procedures',
  impactAreaId: 'POLICIES_AND_PROCEDURES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
